import { render } from "./QuantityPrompt.vue?vue&type=template&id=2131a5e2&scoped=true"
import script from "./QuantityPrompt.vue?vue&type=script&lang=js"
export * from "./QuantityPrompt.vue?vue&type=script&lang=js"

import "./QuantityPrompt.vue?vue&type=style&index=0&id=2131a5e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2131a5e2"]])

export default __exports__